import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import NotFound from '@/Page/NotFoundPage';
import Head from 'next/head';
import { sharedServerSideLogic } from '@/Services/SsrService/sharedServerSideLogic';

export default function NotFoundProduct() {
  const { t } = useTranslation(['common']);

  return (
    <>
      <Head>
        <title>{t('nothing_found')} | Joyla.uz</title>
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <>
        <NotFound />
      </>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = sharedServerSideLogic();
